export const POLL_INTERVAL_MS = {
  DASHBOARD_SERVICES: 15_000,
  DASHBOARD_SERVICE_COMPONENTS: 15_000,
  DASHBOARD_ALERTS: 60_000,
  SERVICE_DETAILS: 15_000,
  BGP_SESSIONS_STATS: 60_000,
} as const

export const pollQueryOptions = (intervalMs: number) => ({
  refetchInterval: intervalMs,
  refetchIntervalInBackground: false,
})

export const dashboardServicesPollOptions = pollQueryOptions(
  POLL_INTERVAL_MS.DASHBOARD_SERVICES
)

export const dashboardServiceComponentsPollOptions = pollQueryOptions(
  POLL_INTERVAL_MS.DASHBOARD_SERVICE_COMPONENTS
)

export const dashboardAlertsPollOptions = pollQueryOptions(
  POLL_INTERVAL_MS.DASHBOARD_ALERTS
)

export const serviceDetailsPollOptions = pollQueryOptions(
  POLL_INTERVAL_MS.SERVICE_DETAILS
)

export const bgpSessionsStatsPollOptions = pollQueryOptions(
  POLL_INTERVAL_MS.BGP_SESSIONS_STATS
)

/** Merge default service-detail polling with per-query overrides (e.g. `enabled`). */
export const withServiceDetailsPoll = (params?: Record<string, unknown>) => ({
  ...serviceDetailsPollOptions,
  ...params,
})
